import React, { useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Row, Spinner, Input } from "reactstrap";
import { MdEdit, MdDelete } from "react-icons/lib/md";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import "./TablaCompromisos.css";

/**
 * Componente TablaCompromisos para listar los compromisos registrados.
 *
 * @param {object} props
 * @param {Array} props.compromisos - Lista de compromisos a mostrar
 * @param {boolean} props.isLoading - Flag de carga
 * @param {function} props.onEditar - Callback al presionar Editar
 * @param {function} props.onEliminar - Callback al presionar Eliminar
 * @param {boolean} props.puedeVerTiempoCreacion - Flag para mostrar el tiempo desde creación
 */
const TablaCompromisos = ({ compromisos, isLoading, puedeVerTiempoCreacion }) => {
    const [first, setFirst] = useState(0);

    const rows = 20;

    const total = compromisos.length;

    const desde =
        total === 0
            ? 0
            : first + 1;

    const hasta =
        Math.min(first + rows, total);

    const formatearEjecutivo = (valor) => {

        if (!valor) {
            return "";
        }

        const inicioCorreo = valor.indexOf("(");

        if (inicioCorreo === -1) {
            return valor.toUpperCase();
        }

        const nombre =
            valor.substring(0, inicioCorreo).trim();

        const correo =
            valor.substring(inicioCorreo).trim();

        return (
            <>
                {nombre.toUpperCase()}{" "}
                {correo}
            </>
        );
    };

    const accionesTemplate = () => {
        return (
            <button
                type="button"
                className="btn-acciones-compromiso"
                onClick={(e) => e.preventDefault()}
            >
                <span className="puntos-acciones">⋮</span>
            </button>
        );
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center p-5">
                <Spinner color="primary" />
                <span className="ml-3 font-weight-bold">Cargando compromisos...</span>
            </div>
        );
    }


    return (
        <div>
            <Row>

                <Col>
                    <div
                        style={{
                            marginBottom: "12px",
                            fontSize: "14px",
                            color: "#676767"
                        }}
                    >
                        Mostrando {desde}-{hasta} de {total} compromisos
                    </div>
                    <Card body>


                        <DataTable
                            key={JSON.stringify(compromisos)}
                            value={compromisos}
                            responsive
                            className="p-datatable-customers"
                            rowHover
                            first={first}
                            onPage={(event) =>
                                setFirst(event.first)
                            }
                            paginator
                            rows={rows}
                            rowsPerPageOptions={[20]}
                            emptyMessage="No se han encontrado resultados"
                            resizableColumns
                            filterDisplay="row"
                        >

                            <Column
                                className="counter"
                                field="compromiso"
                                header="# COMPROMISO"
                                filter
                                filterMatchMode="contains"
                            />
                            <Column
                                field="fecha"
                                header="FECHA"
                                filter

                            />
                            <Column field="cliente"
                                header="CLIENTE"
                                filter
                                filterMatchMode="contains"
                                body={(rowData) =>
                                    rowData.cliente
                                        ? rowData.cliente.toUpperCase()
                                        : ""}
                            />


                            <Column field="lineaNegocio"
                                header="LÍNEA DE NEGOCIO"
                                filter
                                filterMatchMode="contains"
                                body={(rowData) =>
                                    rowData.lineaNegocio
                                        ? rowData.lineaNegocio.toUpperCase()
                                        : ""}
                            />
                            <Column
                                field="estado"
                                header="ESTADO"
                                className="text-center"
                                filter
                                filterMatchMode="contains"
                                body={(rowData) =>
                                    rowData.estado
                                        ? rowData.estado.toUpperCase()
                                        : ""}
                            />
                            <Column
                                field="broker"
                                header="BROKER"
                                filter
                                filterMatchMode="contains"
                                body={(rowData) =>
                                    rowData.broker
                                        ? rowData.broker.toUpperCase()
                                        : ""}
                            />
                            <Column field="ejecutivoAsignado"
                                header="EJECUTIVO ASIGNADO"
                                filter
                                filterMatchMode="contains"
                                body={(rowData) =>
                                    formatearEjecutivo(
                                        rowData.ejecutivoAsignado
                                    )
                                }
                            />
                            <Column
                                field="primaNeta"
                                header="PRIMA NETA"
                                filter
                                filterMatchMode="contains"
                                body={(rowData) => `$${rowData.primaNeta}`}
                            />
                            <Column
                                    field="tiempoRestante"
                                    header="TIEMPO RESTANTE"
                                    filter
                                    filterMatchMode="contains"
                                    body={(rowData) =>
                                        rowData.tiempoRestante
                                            ? rowData.tiempoRestante.toUpperCase()
                                            : ""}
                            />
                        
                            <Column
                                field="acciones"
                                header="ACCIONES"
                                body={accionesTemplate}
                                className="text-center"
                            />


                        </DataTable>
                    </Card>
                </Col>
            </Row>
        </div>

    );
};

export default TablaCompromisos;
